import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import GeoJSON from "ol/format/GeoJSON";
import { map, ParcelLayer, BlocksNonRegisteredLayer } from './Map';
import { GEOSERVER_WFS_URL, SEARCH_CONFIG } from './Config';
import { closeSidebarOnMobile } from './CustomFunctions';

const wfsUrl = GEOSERVER_WFS_URL;

// 🔒 Secure AJAX helper — wraps secureFetch to send JWT with every WFS request
// Mimics $.ajax({ url, data, success, error }) interface for minimal code changes
function secureAjax({ url, data, success, error }) {
  const params = new URLSearchParams(data).toString();
  const fullUrl = `${url}?${params}`;
  const fetchFn = window.secureFetch || fetch;

  fetchFn(fullUrl)
    .then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then(json => { if (success) success(json); })
    .catch(err => {
      console.error('[SecureWFS]', err);
      if (error) error(err);
    });
}

// ✅ طبقة نتائج البحث
const vectorSource = new VectorSource();
const vector = new VectorLayer({
  source: vectorSource,
  style: new Style({
    stroke: new Stroke({ color: "rgba(0, 247, 255, 1)", width: 3 }),
    fill: new Fill({ color: "rgba(0, 247, 255, 0.14)" }),
  }),
});
map.addLayer(vector);

// ✅ جلب القيم Autocomplete
let govList = [];
let villageList = [];
let blockList = [];

// دالة هروب الاقتباسات لاستخدامها في كل مكان
const esc = (s) => String(s).replace(/'/g, "''");

// Helper to find property value case-insensitively
const getProp = (props, key) => {
  if (!props) return null;
  const k = Object.keys(props).find(k => k.toLowerCase() === key.toLowerCase());
  return k ? props[k] : null;
};

// 1. Governorates (No Filter)
let searchMode = 'registration'; // 'registration' or 'natural'

// ✅ Accordion Mode Switcher Logic
const searchBox = $(".search-box");

// Mode: Registration
$("#btn-search-reg").click(function () {
  if (searchMode === 'registration') return; // Already active

  // Update State
  searchMode = 'registration';

  // UI Updates
  $("#btn-search-reg").addClass('active');
  $("#btn-search-nat").removeClass('active');

  $("#container-reg").show();
  $("#container-nat").hide();

  // Move Form first, then History at bottom
  searchBox.appendTo("#container-reg");
  $("#searchHistoryList").appendTo("#container-reg");

  // ✅ Smart Layer Toggling
  ParcelLayer.setVisible(true);
  BlocksNonRegisteredLayer.setVisible(false);

  // Show Fields
  $("#quarterInput").show();
  $("#parcelInput").show();
  $("#blockInput").attr("placeholder", "رقم الحوض");

  // Reset & Fetch
  resetSearchFields();
  fetchGovernorates();
  displaySearchHistory(); // Refresh history for this mode
});

// Mode: Natural
$("#btn-search-nat").click(function () {
  if (searchMode === 'natural') return; // Already active

  // Update State
  searchMode = 'natural';

  // UI Updates
  $("#btn-search-nat").addClass('active');
  $("#btn-search-reg").removeClass('active');

  $("#container-nat").show();
  $("#container-reg").hide();

  // Move Form first, then History at bottom
  searchBox.appendTo("#container-nat");
  $("#searchHistoryList").appendTo("#container-nat");

  // ✅ Smart Layer Toggling
  ParcelLayer.setVisible(false);
  BlocksNonRegisteredLayer.setVisible(true);

  // Hide Fields
  $("#quarterInput").hide();
  $("#parcelInput").hide();
  $("#blockInput").attr("placeholder", "اسم الحوض");

  // Reset & Fetch
  resetSearchFields();
  fetchGovernorates();
  displaySearchHistory(); // Refresh history for this mode
});

function resetSearchFields() {
  $("#govInput").val('');
  $("#villageInput").val('');
  $("#blockInput").val('');
  $("#quarterInput").val('').prop('disabled', true);
  $("#parcelInput").val('');

  // ✅ Clear autocomplete sources to prevent mixing between modes
  govList = [];
  villageList = [];
  blockList = [];
}

// Initial Fetch
fetchGovernorates();

function fetchGovernorates() {
  govList = [];

  const isNatural = searchMode === 'natural';
  const typeName = isNatural
    ? "DataBase:blocks_non_registered_gov_view"
    : "DataBase:new_parcel_gov_view";

  // For Natural, fetch all properties to avoid case-sensitivity issues
  const dataParams = {
    service: "WFS",
    version: "1.1.0",
    request: "GetFeature",
    typeName: typeName,
    outputFormat: "application/json",
    maxFeatures: SEARCH_CONFIG.autocompleteLimit
  };

  // Only restrict property for Registration mode to save bandwidth (we know it works)
  if (!isNatural) {
    dataParams.propertyName = "gov_a";
  }

  secureAjax({
    url: wfsUrl,
    data: dataParams,
    success: function (data) {
      processGovData(data, false);
      // Fallback check (silent)
      if (govList.length === 0 && isNatural) {
        fetchGovFallback();
      }
    },
    error: function () {
      console.warn("View failed, trying fallback...");
      if (isNatural) {
        fetchGovFallback();
      }
    }
  });
}

function fetchGovFallback() {
  console.log("Starting Gov Fallback...");
  secureAjax({
    url: wfsUrl,
    data: {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      typeName: "DataBase:blocks_non_registered",
      // ✅ OPTIMIZATION: Fetch ONLY needed columns to avoid huge Geometry payload
      propertyName: "governorat",
      outputFormat: "application/json",
      maxFeatures: 2000
    },
    success: function (data) {
      console.log("Gov Fallback Data:", data);
      processGovData(data, true);
    },
    error: function (xhr) {
      console.error("Failed to load gov list fallback", xhr.responseText);
    }
  });
}

function processGovData(data, isFallback) {
  const temp = [];
  (data.features || []).forEach((f) => {
    let g;
    if (searchMode === 'natural') {
      // Try 'governorat' or 'governorate' or 'gov_a' etc
      g = getProp(f.properties, 'governorat') || getProp(f.properties, 'governorate');
    } else {
      g = f.properties?.gov_a;
    }

    if (g && !temp.includes(g)) temp.push(g);
  });
  govList = temp.sort();
  const govInput = $("#govInput");

  // Destroy old autocomplete to re-init with new source if needed, or just update source
  if (govInput.data("ui-autocomplete")) {
    govInput.autocomplete("option", "source", govList);
  } else {
    govInput.autocomplete({
      source: govList,
      minLength: 0,
      select: function (event, ui) {
        $("#villageInput").val('');
        $("#blockInput").val('');
        fetchVillages(ui.item.value);
      },
    }).focus(function () {
      $(this).autocomplete("search", "");
    });
  }
}

function fetchVillages(govName) {
  villageList = [];
  const isNatural = searchMode === 'natural';

  const typeName = isNatural
    ? "DataBase:blocks_non_registered_village_view"
    : "DataBase:new_parcel_village_view";

  const govCol = isNatural ? "governorat" : "gov_a";

  const dataParams = {
    service: "WFS",
    version: "1.1.0",
    request: "GetFeature",
    typeName: typeName,
    outputFormat: "application/json",
    CQL_FILTER: `${govCol}='${esc(govName)}'`,
    maxFeatures: SEARCH_CONFIG.autocompleteLimit
  };

  if (!isNatural) dataParams.propertyName = "village_a";

  secureAjax({
    url: wfsUrl,
    data: dataParams,
    success: function (data) {
      processVillageData(data, false, govName);
      if (villageList.length === 0 && isNatural) {
        fetchVillagesFallback(govName);
      }
    },
    error: function () {
      if (isNatural) {
        fetchVillagesFallback(govName);
      } else {
        showSearchError("خطأ في الاتصال", "تعذر جلب قائمة القرى.");
      }
    }
  });
}

function fetchVillagesFallback(govName) {
  secureAjax({
    url: wfsUrl,
    data: {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      typeName: "DataBase:blocks_non_registered",
      propertyName: "communityn", // ✅ Optimization
      outputFormat: "application/json",
      CQL_FILTER: `governorat='${esc(govName)}'`,
      maxFeatures: 2000
    },
    success: function (data) {
      processVillageData(data, true, govName);
    }
  });
}

function processVillageData(data, isFallback, govName) {
  const temp = [];
  (data.features || []).forEach((f) => {
    let v;
    if (searchMode === 'natural') {
      v = getProp(f.properties, 'communityn') || getProp(f.properties, 'community') || getProp(f.properties, 'village');
    } else {
      v = f.properties?.village_a;
    }
    if (v && !temp.includes(v)) temp.push(v);
  });
  villageList = temp.sort();
  const villageInput = $("#villageInput");

  // ✅ FIX: Destroy and recreate autocomplete to ensure fresh handlers
  if (villageInput.data("ui-autocomplete")) {
    villageInput.autocomplete("destroy");
  }

  villageInput.autocomplete({
    source: villageList,
    minLength: 0,
    select: function (event, ui) {
      $("#blockInput").val('');
      // ✅ FIX: Get current gov from input, not closure
      const currentGov = $("#govInput").val();
      fetchBlocks(currentGov, ui.item.value);
    }
  }).focus(function () {
    $(this).autocomplete("search", "");
  });
}

function fetchBlocks(govName, villageName) {
  blockList = [];
  const isNatural = searchMode === 'natural';

  // For Natural mode, skip unreliable View and query raw table directly
  if (isNatural) {
    fetchBlocksFallbackNatural(govName, villageName);
    return;
  }

  // Registration mode - use View with fallback
  const typeName = "DataBase:new_parcel_block_view";
  const cql = `gov_a='${esc(govName)}' AND village_a='${esc(villageName)}'`;
  const dataParams = {
    service: "WFS",
    version: "1.1.0",
    request: "GetFeature",
    typeName: typeName,
    propertyName: "full_block_name",
    outputFormat: "application/json",
    CQL_FILTER: cql,
    maxFeatures: SEARCH_CONFIG.autocompleteLimit
  };

  secureAjax({
    url: wfsUrl,
    data: dataParams,
    success: function (data) {
      if (!data.features || data.features.length === 0) {
        fetchBlocksFallback(govName, villageName);
      } else {
        processBlockData(data, govName, villageName);
      }
    },
    error: function (xhr) {
      fetchBlocksFallback(govName, villageName);
    }
  });
}

// Fallback for Natural Blocks
function fetchBlocksFallbackNatural(govName, villageName) {
  const cqlFilter = `governorat='${esc(govName)}' AND communityn='${esc(villageName)}'`;

  secureAjax({
    url: wfsUrl,
    data: {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      typeName: "DataBase:blocks_non_registered",
      propertyName: "blocknumbe,blockname_",
      outputFormat: "application/json",
      CQL_FILTER: cqlFilter,
      maxFeatures: SEARCH_CONFIG.autocompleteLimit
    },
    success: function (data) {
      processBlockData({ features: data.features || [] }, govName, villageName);
    },
    error: function () {
      // Silent fail
    }
  });
}

function fetchBlocksFallback(govName, villageName) {
  secureAjax({
    url: wfsUrl,
    data: {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      typeName: "DataBase:New_Parcel", // Fallback to Main Table
      propertyName: "block_no,block_a",
      outputFormat: "application/json",
      CQL_FILTER: "gov_a='" + esc(govName) + "' AND village_a='" + esc(villageName) + "'",
      maxFeatures: SEARCH_CONFIG.autocompleteLimit
    },
    success: function (data) {
      // Construct full_block_name manually from block_no and block_a
      const modifiedFeatures = (data.features || []).map(f => {
        const no = f.properties?.block_no;
        const name = f.properties?.block_a;
        if (no) {
          f.properties.full_block_name = name ? `${no} - ${name}` : `${no}`;
        }
        return f;
      });
      processBlockData({ features: modifiedFeatures }, govName, villageName);
    },
    error: function () {
      showSearchError("خطأ في الاتصال", "تعذر جلب قائمة الأحواض. يرجى التحقق من الاتصال.");
    }
  });
}

function processBlockData(data, govName, villageName) {
  const temp = [];
  (data.features || []).forEach((f) => {
    let b;
    if (searchMode === 'natural') {
      // Prefer extracting raw Name and Number to format nicely
      const name = getProp(f.properties, 'blockname_');
      const num = getProp(f.properties, 'blocknumbe');

      if (name && num) {
        b = `${name} (${num})`;
      } else if (num) {
        b = `${num}`;
      } else {
        // Fallback to view's formatted string if raw cols missing
        b = getProp(f.properties, 'full_block_name');
      }
    } else {
      b = getProp(f.properties, 'full_block_name');
    }

    if (b && !temp.includes(b)) temp.push(b);
  });

  // Sort naturally
  blockList = temp.sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }));
  const blockInput = $("#blockInput");

  // ✅ FIX: Destroy and recreate autocomplete to ensure fresh source and handlers
  if (blockInput.data("ui-autocomplete")) {
    blockInput.autocomplete("destroy");
  }

  blockInput.autocomplete({
    source: blockList,
    minLength: 0,
    select: function (event, ui) {
      // Only fetch Quarters if in registration mode
      if (searchMode === 'registration') {
        $("#quarterInput").val('').prop('disabled', true);
        const currentGov = $("#govInput").val();
        const currentVillage = $("#villageInput").val();
        fetchQuarters(currentGov, currentVillage, ui.item.value);
      }
    }
  }).focus(function () {
    $(this).autocomplete("search", "");
  });
}

function fetchQuarters(govName, villageName, blockName) {
  // Extract block number if format is "Number - Name"
  let blockNo = blockName;
  const match = String(blockName).match(/^(\d+)/);
  if (match) blockNo = match[1];

  secureAjax({
    url: wfsUrl,
    data: {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      typeName: "DataBase:new_parcel_quarter_view",
      propertyName: "quarternam,quarternum",
      outputFormat: "application/json",
      CQL_FILTER: `gov_a='${esc(govName)}' AND village_a='${esc(villageName)}' AND block_no=${esc(blockNo)}`,
      maxFeatures: 50
    },
    success: function (data) {
      // If view returns no features, try fallback
      if (!data.features || data.features.length === 0) {
        fetchQuartersFallback(govName, villageName, blockName);
      } else {
        processQuarterData(data);
      }
    },
    error: function () {
      // Fallback on error
      fetchQuartersFallback(govName, villageName, blockName);
    }
  });
}

function fetchQuartersFallback(govName, villageName, blockName) {
  // Extract block number if format is "Number - Name"
  let blockNo = blockName;
  const match = String(blockName).match(/^(\d+)/);
  if (match) blockNo = match[1];

  secureAjax({
    url: wfsUrl,
    data: {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      typeName: "DataBase:New_Parcel", // Fallback to Main Table
      propertyName: "quarternam,quarternum",
      outputFormat: "application/json",
      CQL_FILTER: `gov_a='${esc(govName)}' AND village_a='${esc(villageName)}' AND block_no=${esc(blockNo)}`,
      maxFeatures: 50
    },
    success: function (data) {
      // Reuse same processing logic
      processQuarterData(data);
    },
    error: function () {
      console.error("Fallback failed too.");
      $("#quarterInput").val("خطأ في الجلب").prop("disabled", true);
    }
  });
}

function processQuarterData(data) {
  console.log("Quarter Data (Processed):", data);
  const quarters = [];
  const tempMap = new Map();

  (data.features || []).forEach((f) => {
    const qName = f.properties?.quarternam || f.properties?.QuarterNam;
    let qNum = f.properties?.quarternum || f.properties?.QuarterNum;

    if (!qNum || qNum === '-' || qNum === 'null') {
      qNum = 'بدون رقم';
    }

    if (qName && qName !== '-' && qName !== 'null') {
      const key = `${qName} (${qNum})`;
      if (!tempMap.has(key)) {
        tempMap.set(key, { name: qName, num: qNum });
        quarters.push(key);
      }
    }
  });

  const quarterInput = $("#quarterInput");
  const hasValidQuarter = quarters.length > 0 && !quarters.some(q => q.includes('- ('));

  if (!hasValidQuarter) {
    quarterInput.val("لا يوجد حي").prop("disabled", true);
  } else {
    quarterInput.val("").prop("disabled", false).attr("placeholder", "اختر الحي (اختياري)");

    if (quarterInput.data("ui-autocomplete")) {
      quarterInput.autocomplete("option", "source", quarters.sort());
    } else {
      quarterInput.autocomplete({
        source: quarters.sort(),
        minLength: 0
      }).focus(function () {
        $(this).autocomplete("search", "");
      });
    }
  }
}

// ✅ البحث
let isSearching = false;

// ✅ متغير عام للاحتفاظ بآخر AbortController لإلغاء الطلب السابق
let searchAbort;

$("#search").click(function () {
  if (isSearching) return;

  const gov = $("#govInput").val()?.trim();
  const village = $("#villageInput").val()?.trim();
  const parcel = $("#parcelInput").val()?.trim();
  const block = $("#blockInput").val()?.trim();

  if (!gov && !village && !parcel && !block) {
    showSearchError("حقول البحث فارغة", "أدخل قيمة واحدة على الأقل");
    return;
  }

  // NOTE: Block name might contain text now, so numeric check removed for block
  if (parcel && !/^\d+$/.test(parcel)) {
    showSearchError("خطأ", "رقم القطعة يجب أن يحتوي أرقام فقط");
    return;
  }

  performSearch({ gov, village, parcel, block });
});

function buildCqlFilter({ gov, village, parcel, block }) {
  const parts = [];

  if (searchMode === 'natural') {
    // NATURAL BLOCKS FILTER
    // mapping: gov_a -> governorat, village_a -> communityn, block_no -> blocknumbe
    if (gov) parts.push(`governorat='${esc(gov)}'`);
    if (village) parts.push(`communityn='${esc(village)}'`);

    if (block) {
      // Check for "Name (Number)" pattern from autocomplete
      const nameMatch = String(block).match(/(.+)\s*\((\d+)\)$/);
      // Check for "Number - Name" pattern (legacy/view)
      const numMatch = String(block).match(/^(\d+)\s*-\s*(.+)$/);

      if (nameMatch) {
        // Found "Name (8)", use NAME for search (user requested this)
        const blockName = nameMatch[1].trim();
        parts.push(`blockname_='${esc(blockName)}'`);
      } else if (numMatch) {
        // Found "8 - Name", use Number
        parts.push(`blocknumbe=${esc(numMatch[1])}`);
      } else if (/^\d+$/.test(block)) {
        // Just a number "8"
        parts.push(`blocknumbe=${esc(block)}`);
      } else {
        // Just a name "Wadi", use LIKE for partial match on Name
        // Note: blockname_ might vary in DB, using ILIKE logic involves backend support, 
        // but WFS usually supports 'Like'. We'll use exact match or Like with wildcards.
        // Let's assume exact match if selected from list (but here it isn't), 
        // so add wildcards for better UX. 
        parts.push(`blockname_ LIKE '%${esc(block)}%'`);
      }
    }
  } else {
    // REGISTRATION PARCELS FILTER
    if (gov) parts.push(`gov_a='${esc(gov)}'`);
    if (village) parts.push(`village_a='${esc(village)}'`);
    if (parcel) parts.push(`plot_no=${esc(parcel)}`);

    if (block) {
      // Check for "Number - Name" format (e.g. "4 - خلة عبيد")
      const match = String(block).match(/^(\d+)/);
      if (match) {
        // Extract just the number for block_no
        parts.push(`block_no=${match[1]}`);
      } else {
        // Text without number - try block_a field with quotes
        parts.push(`block_a='${esc(block)}'`);
      }
    }

    const quarter = $("#quarterInput").val();
    if (quarter && quarter !== "لا يوجد حي" && quarter !== "خطأ في الجلب" && quarter !== "") {
      const qMatch = quarter.match(/\((\d+)\)$/);
      if (qMatch) {
        parts.push(`quarternum=${qMatch[1]}`);
      }
    }
  }

  return parts.length ? parts.join(" AND ") : "INCLUDE";
}

// ✅ Search History Logic (Corporate Style) - Mode-Aware
const HISTORY_KEY_REG = 'geopst_search_history_reg';
const HISTORY_KEY_NAT = 'geopst_search_history_nat';

function getHistoryKey() {
  return searchMode === 'natural' ? HISTORY_KEY_NAT : HISTORY_KEY_REG;
}

function keepSearchHistory(query) {
  const key = getHistoryKey();
  let history = JSON.parse(localStorage.getItem(key) || '[]');
  // Avoid duplicates - check if same query exists
  const isDuplicate = history.some(h =>
    h.gov === query.gov && h.village === query.village &&
    h.parcel === query.parcel && h.block === query.block
  );
  if (isDuplicate) return;

  history.unshift(query);
  history = history.slice(0, 3); // Keep only last 3 searches
  localStorage.setItem(key, JSON.stringify(history));
  displaySearchHistory();
}

function displaySearchHistory() {
  const key = getHistoryKey();
  let history = JSON.parse(localStorage.getItem(key) || '[]');
  history = history.slice(0, 3); // Force limit to 3 for display as well
  const container = $('#searchHistoryList');
  if (!container.length) return;

  if (history.length === 0) {
    container.hide();
    return;
  }

  container.show();
  const title = searchMode === 'natural' ? 'عمليات البحث الأخيرة (أحواض طبيعية):' : 'عمليات البحث الأخيرة:';
  let html = `<div class="recent-search-title" style="font-size: 11px; font-weight: bold; margin: 10px 0 5px; color: var(--text-muted);">${title}</div>`;
  history.forEach((h, i) => {
    let label;
    if (searchMode === 'natural') {
      label = [h.gov, h.village, h.block ? 'حوض ' + h.block : ''].filter(Boolean).join(' - ');
    } else {
      label = [h.gov, h.village, h.block ? 'حوض ' + h.block : '', h.parcel ? 'قطعة ' + h.parcel : ''].filter(Boolean).join(' - ');
    }
    html += `
      <div class="recent-search-item themed-history-item" data-index="${i}">
        <i class="fas fa-history"></i> ${label}
      </div>
    `;
  });
  container.html(html);
}

window.applyRecentSearch = function (index) {
  const key = getHistoryKey();
  const history = JSON.parse(localStorage.getItem(key) || '[]');
  const h = history[index];
  if (!h) return;

  $("#govInput").val(h.gov || '');
  $("#villageInput").val(h.village || '');
  $("#blockInput").val(h.block || '');
  $("#parcelInput").val(h.parcel || '');

  $("#search").trigger('click');
};

$(document).ready(() => {
  // ✅ Migrate old history to new format (one-time)
  const OLD_KEY = 'geopst_search_history';
  const oldHistory = localStorage.getItem(OLD_KEY);
  if (oldHistory && !localStorage.getItem(HISTORY_KEY_REG)) {
    localStorage.setItem(HISTORY_KEY_REG, oldHistory);
    localStorage.removeItem(OLD_KEY); // Clean up old key
  }

  // Add history list container if missing (position at BOTTOM)
  if (!$('#searchHistoryList').length) {
    $('.search-box').after('<div id="searchHistoryList" style="margin-top:10px;"></div>');
  }

  // ⚡ Level 3: Event Delegation for history items
  $('#searchHistoryList').on('click', '.themed-history-item', function () {
    const idx = $(this).data('index');
    applyRecentSearch(idx);
  });

  displaySearchHistory();
});

function performSearch({ gov, village, parcel, block }) {
  // ✅ 1) ألغِ أي طلب سابق قبل بدء طلب جديد
  if (searchAbort) searchAbort.abort();
  searchAbort = new AbortController();

  isSearching = true;
  const searchBtn = $("#search");
  const originalText = searchBtn.html();
  searchBtn.html('<i class="fas fa-spinner fa-spin"></i> جاري البحث...');
  searchBtn.prop("disabled", true);

  vectorSource.clear();

  // ✅ 2) اجعل الحد ديناميكيًا: أقل للبحث العام، أكبر للبحث الضيق
  const isNarrow = !!parcel || !!block || (gov && village);
  const limit = isNarrow ? SEARCH_CONFIG.maxFeaturesNarrow : SEARCH_CONFIG.maxFeaturesGeneral;

  // Determine Layer based on Mode
  const typeName = searchMode === 'natural'
    ? "DataBase:blocks_non_registered"
    : "DataBase:New_Parcel";

  const params = new URLSearchParams({
    service: "WFS",
    version: "1.1.0",
    request: "GetFeature",
    typeName: typeName,
    srsName: "EPSG:28191",
    outputFormat: "application/json",
    CQL_FILTER: buildCqlFilter({ gov, village, parcel, block }),
    maxFeatures: limit, // ✅ استخدام الحد الديناميكي
  });

  const fetchFn = window.secureFetch || fetch;
  fetchFn(`${wfsUrl}?${params.toString()}`, { signal: searchAbort.signal })
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.text().then(text => {
        try {
          return JSON.parse(text);
        } catch (e) {
          console.error("Server Response (Not JSON):", text);
          throw new Error("Invalid JSON response from server");
        }
      });
    })
    .then((json) => {
      const feats = json?.features || [];
      if (feats.length > 0) {
        const features = new GeoJSON().readFeatures(json, {
          dataProjection: "EPSG:28191",
          featureProjection: map.getView().getProjection(),
        });
        vectorSource.addFeatures(features);
        map.getView().fit(vectorSource.getExtent(), {
          padding: [50, 50, 50, 50],
          duration: 1000,
          maxZoom: 11
        });

        // على الهاتف، أغلق السايدبار لإظهار النتيجة واستعادة ذيل الموقع
        if (window.innerWidth <= 1024) {
          closeSidebarOnMobile();
        }

        highlightInputs("success");
        // Save to history on success
        keepSearchHistory({ gov, village, parcel, block });
      } else {
        showSearchError("لا توجد نتائج", "تحقق من القيم");
        highlightInputs("error");
      }
    })
    .catch((e) => {
      // تجاهل خطأ الإلغاء المتعمد
      if (e.name === "AbortError") return;
      console.error(e);
      showSearchError("خطأ في الاتصال", "لا يوجد اتصال في الخادم");
    })
    .finally(() => {
      isSearching = false;
      searchBtn.html(originalText).prop("disabled", false);
    });
}

// ✅ زر المسح
$("#clearSearch").click(function () {
  $("#govInput").val('');
  $("#parcelInput").val('');
  $("#blockInput").val('');
  $("#quarterInput").val('').prop('disabled', true);
  $("#villageInput").val('');
  vectorSource.clear();
});

// ✅ إعادة تعيين
$("#resetButton").click(function () {
  $("#govInput, #villageInput, #blockInput, #quarterInput, #parcelInput").val("");
  $("#quarterInput").prop('disabled', true);
  vectorSource.clear();
});

// ✅ الرسائل والستايل
function showSearchError(title, msg) {
  $("#errorMessage").html(`<h4 style="color:red">${title}</h4><p>${msg}</p>`);
  $("#errorModal").show();
}

function highlightInputs(type) {
  const color = type === "success" ? "#28a745" : "#dc3545";
  $("#govInput, #villageInput, #blockInput, #quarterInput, #parcelInput").css({
    "border-color": color,
    "box-shadow": `0 0 0 3px ${color}33`,
  });
  setTimeout(() => {
    $("#govInput, #villageInput, #blockInput, #quarterInput, #parcelInput").css({
      "border-color": "",
      "box-shadow": "",
    });
  }, 2000);
}
